import React, { useState } from 'react'
import s from './OrderTeaserTwo.module.css'
import Image from "next/legacy/image"
import { Button } from '@components/ui'
import Link from 'next/link'
import { useTranslations } from 'next-intl'


export interface IListForm {
  text: string
  icon: string
}

export interface OrderTeaserTwoProps {
  title?: string
  subtitle?: string
  variantId?: string
  buttonText?: string
  image?: any
  logo?: any
  className?: string
  text?: any
  list?: Array<IListForm>
}

const OrderTeaserTwo: React.FC<OrderTeaserTwoProps> = ((props) => {
  let {
    list,
    text,
    className,
    variantId,
    buttonText,
    title,
    subtitle,
    image,
    logo
  } = props

  const t = useTranslations('Product')

  return (
    <div className={`${s.root}`}>
      <div>
        <div className={`hidden md:grid grid-cols-1 lg:grid-cols-2`}>
          <div className={s.titleCover}>
            {image && <div
              className={s.image + ' block w-full h-full block overflow-hidden relative'}>
              <Image priority={false} loading="lazy" alt='Order teaser image' src={image} layout='fill' objectFit='cover' />
            </div>}
          </div>
          <div className='md:mr-0 md:ml-space10 xl:mr-space10'>
            <div className={'h-full w-full relative'}>
              <div className={s.innerWrapper}>
                <div>
                  <h3 className={`${s.title} w-e336 md:w-e446 lg:w-e575`}>{title}<span
                    className={'block text-neutral500'}>{subtitle}</span></h3>
                </div>
                <div>
                  {text &&
                    <div className={'lg:px-10 w-e336 md:w-e446 lg:w-e575'}>
                      <p>{text}</p>
                    </div>
                  }
                  {list &&
                    <div>
                      <ul className={s.list}>
                        {list && list.map((item, index) => {
                          return <li className={s.item + ' relative'} key={index}>
                            <h4 className={`text-neutral900 lh-24 mb-space2`}>
                              <span className={item.icon + ' text-icon22 text-middle md:lh-24'}></span>
                              <span
                                className={'text-paragraph02 md:text-paragraph01 align-top ml-space4'}>{item.text}</span>
                            </h4>
                          </li>
                        })}
                      </ul>
                    </div>
                  }
                </div>
                {logo && logo !== '' &&
                  <div className={'lg:px-10 pt-space4 md:pt-space8'}>
                    {t('partneredWith')}
                    <span className={'inline-block px-space4 align-middle'}>
                    <Image src={logo} width={100} height={34} alt={'parter'} />
                  </span>
                  </div>
                }
                <div className={'lg:px-10'}>
                  <Link href={'/quick-buy?variantId=' + variantId + '&quantity=1'} legacyBehavior passHref>
                    <Button className={'mt-space8'}
                            variant='outlineMedium'
                    >{buttonText}</Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`block md:hidden`}>
          <div className='md:mr-0 md:ml-space10 xl:mr-space10'>
            <div className={'h-full w-full relative'}>
              <div className={s.innerWrapper}>
                <div>
                  <h3 className={`${s.title} w-e336 md:w-e446 lg:w-e575`}>{title}<span
                    className={'block text-neutral500'}>{subtitle}</span></h3>
                </div>
                <div>
                  {text &&
                    <div className={'lg:px-10 w-e336 md:w-e446 lg:w-e575'}>
                      <p>{text}</p>
                    </div>
                  }
                  {list &&
                    <div>
                      <ul className={s.list}>
                        {list && list.map((item, index) => {
                          return <li className={s.item + ' relative'} key={index}>
                            <h4 className={`text-neutral900 lh-24 mb-space2`}>
                              <span className={item.icon + ' text-icon22 text-middle md:lh-24'}></span>
                              <span
                                className={'text-paragraph02 md:text-paragraph01 align-top ml-space4'}>{item.text}</span>
                            </h4>
                          </li>
                        })}
                      </ul>
                    </div>
                  }
                </div>
                {logo && logo !== '' &&
                  <div className={'lg:px-10 pt-space8'}>
                    {t('partneredWith')}
                    <span className={'px-space4 align-middle'}>
                    <Image src={logo} width={100} height={34} alt={'parter'} />
                  </span>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className={s.titleCover}>
            {image && <div
              className={s.image + ' block w-full h-full block overflow-hidden relative'}>
              <Image alt='Order teaser title cover' priority={false} loading="lazy" src={image} layout='fill' objectFit='cover' />
            </div>}
          </div>
          <div className={'lg:px-10 text-center'}>
            <Link href={'/quick-buy?variantId=' + variantId + '&quantity=1'} legacyBehavior passHref>
              <Button className={'mt-space8'}
                      variant='outlineMedium'
              >{buttonText}</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
})

export default OrderTeaserTwo
